import { render, staticRenderFns } from "./bdd-applications.vue?vue&type=template&id=dc358a4a"
import script from "./bdd-applications.vue?vue&type=script&lang=js"
export * from "./bdd-applications.vue?vue&type=script&lang=js"
import style0 from "./bdd-applications.vue?vue&type=style&index=0&id=dc358a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports